<div class="container-fluid">
    <h4>{{'Menus.header' | translate}}</h4>
    <div class="row mt-4">
        <div class="col-4">
            <div style="width: 250px; font-size: small;">
                <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl">
                    <!-- Leaf nodes -->
                    <mat-tree-node *matTreeNodeDef="let node">
                        <li class="mat-tree-node">
                            <button mat-icon-button (mouseenter)="onMouseEnterTrigger(node)" (mouseleave)="onMouseLeaveTrigger()"
                                    (click)="onClickNode(node)">
                                <mat-icon fontSet="material-icons-outlined">{{ node.icon }}</mat-icon>
                            </button>
                            <span class="clickable" (click)="onClickNode(node)">{{ node.name }}</span>
                        </li>
                    </mat-tree-node>

                    <!-- Expandable nodes -->
                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodeToggle>
                        <li class="mat-tree-node">
                            <button mat-icon-button (mouseenter)="onMouseEnterTrigger(node)" (mouseleave)="onMouseLeaveTrigger()"
                                    (click)="onClickNode(node)">
                                <mat-icon fontSet="material-icons-outlined">{{ node.icon }}</mat-icon>
                            </button>
                            <span class="clickable" matTreeNodeToggle (click)="onClickNode(node)">{{ node.name }}</span>
                            <button mat-icon-button style="margin-left:auto;" matTreeNodeToggle>
                                <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </button>
                        </li>

                        <!-- Hover menu panel -->
                        <div *ngIf="hoveredNode === node && service.miniSidebarOpen" class="hoverThing"
                             (mouseenter)="onMouseEnterDropdown()" (mouseleave)="onMouseLeaveDropdown()">
                            <div class="mat-tree-node">
                                <span class="clickable" (click)="onClickNode(node)">{{ node.name }}</span>
                            </div>
                            <ul *ngIf="node.childMenus?.length > 0">
                                <li *ngFor="let child of node.childMenus" class="mat-tree-node">
                                    <span class="clickable" (click)="onClickNode(child)">{{ child.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </mat-tree-node>
                </mat-tree>
            </div>
        </div>

        <div class="col-8" *ngIf="selectedSidebarMenu !== undefined">
            <div [@slideVertical]="selectedSidebarMenu !== undefined ? 'show' : null">
                <h5>{{ selectedSidebarMenu.name }}</h5>
                <div class="mat-elevation-z8 mt-3">
                    <div class="scrollableTable">
                        <table mat-table [dataSource]="selectedSidebarMenu.roles">
                            <ng-container matColumnDef="role">
                                <th mat-header-cell *matHeaderCellDef style="width: 60%;">
                                    {{ 'Menus.thRoles' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                            </ng-container>

                            <ng-container matColumnDef="enabled">
                                <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: center;">
                                    {{ 'Menus.thEnabled' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                    <mat-checkbox color="primary" [(ngModel)]="element.enabled"
                                                  (change)="element.enabled === false ? element.default = false : element.default = element.default;"
                                                  [ngModelOptions]="{standalone: true}">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="default">
                                <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: center;">
                                    {{ 'Menus.thDefault' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                    <mat-checkbox color="primary" [disabled]="!element.enabled"
                                                  [(ngModel)]="element.default"
                                                  [ngModelOptions]="{standalone: true}">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayColumns;"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                        </table>
                    </div>
                </div>

                <!-- Save Button: only shown if not readonly -->
                <div class="mt-2" *ngIf="!service.currentUser.isReadOnly">
                    <button mat-raised-button style="float: right;" color="primary" type="button" (click)="onSaveChanges()">
                        {{ 'btnSave' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
